.body {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
  margin: 0 auto;
  max-width: 1600px;
  padding: var(--pgm-sys-spacing-10) var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-16);
  width: 100%;
}

.header {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-4);
}

.title {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.notice {
  align-items: center;
  background-color: var(--pgm-sys-color-warning-container);
  border-radius: 4px;
  color: var(--pgm-sys-color-on-warning-container);
  display: flex;
  gap: var(--pgm-sys-spacing-2);
  margin: 0;
  padding: var(--pgm-sys-spacing-2) var(--pgm-sys-spacing-3);
}

.noticeIcon {
  font-size: 24px;
  font-variation-settings:
    "FILL" 1,
    "wght" 500,
    "GRAD" 0,
    "opsz" 24;
  line-height: 24px;
}

.grid {
  align-items: start;
  display: grid;
  gap: var(--pgm-sys-spacing-6);
  grid-template-columns: repeat(12, minmax(0, 1fr));
}

.bulkProtocols {
  grid-column: 1 / -1;
}

.field {
  grid-column: span 4;
}

.submit {
  align-self: center;
  grid-column: span 1;
  justify-self: start;
  min-width: max-content;
}

.successMessage {
  align-items: center;
  background-color: var(--pgm-sys-color-success-container);
  border-radius: 12px;
  display: flex;
  gap: var(--pgm-sys-spacing-4);
  padding: var(--pgm-sys-spacing-6);
}

.successIcon {
  color: var(--pgm-sys-color-on-success-container);
  flex-shrink: 0;
  font-size: 28px;
  font-variation-settings:
    "FILL" 1,
    "wght" 500,
    "GRAD" 0,
    "opsz" 24;
  line-height: 28px;
}

.successText {
  color: var(--pgm-sys-color-on-success-container);
  margin: 0;
  white-space: pre-line;
}

.errorMessage {
  align-items: center;
  background-color: var(--pgm-sys-color-error-container);
  border-radius: 12px;
  display: flex;
  gap: var(--pgm-sys-spacing-4);
  padding: var(--pgm-sys-spacing-6);
}

.errorIcon {
  color: var(--pgm-sys-color-on-error-container);
  flex-shrink: 0;
  font-size: 28px;
  font-variation-settings:
    "FILL" 1,
    "wght" 500,
    "GRAD" 0,
    "opsz" 24;
  line-height: 28px;
}

.errorText {
  color: var(--pgm-sys-color-on-error-container);
  margin: 0;
  white-space: pre-line;
}

.actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: var(--pgm-sys-spacing-4);
}

@media (max-width: 1024px) {
  .grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .field,
  .submit {
    grid-column: 1 / -1;
  }

  .submit {
    justify-self: stretch;
  }
}

@media (max-width: 599.98px) {
  .body {
    padding: var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-4) var(--pgm-sys-spacing-12);
  }
}

.passwordToggle {
  color: var(--pgm-sys-color-on-surface-variant);
  cursor: pointer;
}
